var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealtimeProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 840 550",
    style: {
      enableBackground: "new 0 0 840 550"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.realtime-st0{opacity:0.9;}\n\t.realtime-st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n", "\n\t.realtime-st2{fill:#B3E1E1;}\n", "\n\t.realtime-st3{fill:#339999;}\n", "\n\t.realtime-st4{fill:#8CD1D1;}\n\t.realtime-st5{fill:none;stroke:#006A6A;stroke-width:4.4283;stroke-linecap:round;stroke-miterlimit:10;}\n\t.realtime-st6{fill:#006A6A;}\n\t.realtime-st7{fill:none;stroke:#660033;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "realtime-st0"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "realtime-st1",
    points: "831.83,538.72 9.38,538.72 9.38,9.72  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.88,
    y: 354.08,
    className: "realtime-st2",
    width: 60,
    height: 183.72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.88,
    y: 9.72,
    className: "realtime-st3",
    width: 60,
    height: 528.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.88,
    y: 246.06,
    className: "realtime-st4",
    width: 60,
    height: 292.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.88,
    y: 139.89,
    className: "realtime-st3",
    width: 60,
    height: 397.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.17,
    y: 179.59,
    className: "realtime-st4",
    width: 60,
    height: 358.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.88,
    y: 437.17,
    className: "realtime-st2",
    width: 60,
    height: 100.63
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "realtime-st3",
    points: "725.88,537.8 665.88,537.8 665.88,294.07 725.88,294.07 725.88,537.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "realtime-st2",
    points: "831.38,537.8 771.38,537.8 771.38,82.66 831.38,82.66 831.38,537.8  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "line_x5F_g_00000041976432233852173300000004616253944338580401_",
    className: "realtime-st5",
    d: "M11.38,536.38l130.89-88.98 c0.39-0.19,112.19-80.39,112.61-80.39l74.7,63.74c1.04,0,2.03-0.6,2.69-1.63l115.28-179.76c1-1.56,2.7-2.06,4.14-1.23l145.54,84.71 c1.06,0.61,2.28,0.52,3.27-0.26l225.91-177.35"
  }), /*#__PURE__*/React.createElement("g", {
    id: "dots"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse_x5F_4",
    className: "realtime-st6",
    cx: 255.78,
    cy: 366.01,
    rx: 4.73,
    ry: 6.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse_x5F_3",
    className: "realtime-st6",
    cx: 332.79,
    cy: 428.83,
    rx: 4.73,
    ry: 6.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse_x5F_2",
    className: "realtime-st6",
    cx: 449.4,
    cy: 247.43,
    rx: 4.73,
    ry: 6.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse_x5F_1",
    className: "realtime-st6",
    cx: 599.8,
    cy: 333.24,
    rx: 4.73,
    ry: 6.04
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse_x5F_2_00000057834059175405253660000005998886764329691570_",
    className: "realtime-st6",
    cx: 826.2,
    cy: 153.78,
    rx: 4.78,
    ry: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "realtime-st7",
    points: "12.37,301.9 172.61,500.96 357.51,240.4 555.75,399.61 674.86,185.07 831.38,82.72  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealtimeProcessing);
export default __webpack_public_path__ + "static/media/realtime-processing.1dbb90435a8bab53d929b0ba027a6857.svg";
export { ForwardRef as ReactComponent };